import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './writing.json';

const Writing = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Writing skills, composition techniques, and academic English. B2/C1 level grammar, vocabulary, and writing exercises."
            level="B2"
            title="Writing"
            image="/Images/writing.webp"
            seoTitle="Free English Lesson Plans: Writing"
            seoDescription="Practice English with exercises on handwriting, digital writing, punctuation, and AI. B2 level grammar, vocabulary, reading, and discussion activities."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
                ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Writing;